import React from "react";

import { Box } from "@chakra-ui/react";
import { Link, useParams } from "react-router-dom";
import { ROUTES } from "routes/constants";

import { Tabs } from "ui/tabs";
import { ITabsData } from "ui/tabs/types";

import {
  BUSINESS_DETAILS_TAB_CONTENT_LIST,
  BusinessDetailsTabStatus,
} from "../consts";
import { IBusinessDetailsContentProps } from "./types";

export const formatBusinessDetailsRoute = (
  route: string,
  businessId: string
) => {
  return route.replace(":businessId", businessId);
};

export const BusinessDetailsContent = (props: IBusinessDetailsContentProps) => {
  const { businessDetailsCurrentTab } = props;
  const { businessId } = useParams();

  const tabHeadersAsLinks: ITabsData[] = [
    {
      value: BusinessDetailsTabStatus.details,
      content: (
        <Link
          to={formatBusinessDetailsRoute(
            ROUTES.BUSINESS_DETAILS_PAGE,
            businessId || ""
          )}
        >
          Details
        </Link>
      ),
    },
    {
      value: BusinessDetailsTabStatus.accounts,
      content: (
        <Link
          to={formatBusinessDetailsRoute(
            ROUTES.BUSINESS_DETAILS_ACCOUNTS_PAGE,
            businessId || ""
          )}
        >
          Accounts
        </Link>
      ),
    },
    {
      value: BusinessDetailsTabStatus.transactions,
      content: (
        <Link
          to={formatBusinessDetailsRoute(
            ROUTES.BUSINESS_DETAILS_TRANSACTIONS_PAGE,
            businessId || ""
          )}
        >
          Transactions
        </Link>
      ),
    },
    {
      value: BusinessDetailsTabStatus.yield,
      content: (
        <Link
          to={formatBusinessDetailsRoute(
            ROUTES.BUSINESS_DETAILS_YIELD_PAGE,
            businessId || ""
          )}
        >
          Yield
        </Link>
      ),
    },
    {
      value: BusinessDetailsTabStatus.admins,
      content: (
        <Link
          to={formatBusinessDetailsRoute(
            ROUTES.BUSINESS_DETAILS_ADMINS_PAGE,
            businessId || ""
          )}
        >
          Admins
        </Link>
      ),
    },
    {
      value: BusinessDetailsTabStatus.employees,
      content: (
        <Link
          to={formatBusinessDetailsRoute(
            ROUTES.BUSINESS_DETAILS_EMPLOYEES_PAGE,
            businessId || ""
          )}
        >
          Employees
        </Link>
      ),
    },
    {
      value: BusinessDetailsTabStatus["on-demand-pay"],
      content: (
        <Link
          to={formatBusinessDetailsRoute(
            ROUTES.BUSINESS_DETAILS_ODP_PAGE,
            businessId || ""
          )}
        >
          On-Demand Pay
        </Link>
      ),
    },
    {
      value: BusinessDetailsTabStatus.payroll,
      content: (
        <Link
          to={formatBusinessDetailsRoute(
            ROUTES.BUSINESS_DETAILS_PAYROLL_PAGE,
            businessId || ""
          )}
        >
          Payroll
        </Link>
      ),
    },
  ];

  return (
    <Box>
      <Tabs
        defaultTabValue={businessDetailsCurrentTab}
        headers={tabHeadersAsLinks}
        contentList={BUSINESS_DETAILS_TAB_CONTENT_LIST}
        renderTabNavAsLink
        tabsListHeaderCss={{ display: "flex" }}
        tabsContentCss={{ padding: 0, marginBottom: "8px" }}
        renderTabContentOnActiveAndNotWhenTabsComponentMount
      />
    </Box>
  );
};
